<ng-container *ngIf="cardData">
  <ng-container *ngIf="cardType === 'paragraph'">
    <div class="paragraph">
      <label [style.visibility]="'visible'">Paragraph
        <span>{{cardData.length}} words</span>
      </label>
      <div class="dataField">
        <quill-editor [(ngModel)]="cardData" [theme]="'snow'" [readOnly]="true">
        </quill-editor>
      </div>
      <span></span>
      <div class="storyaction">
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="cardType === 'listicle'">

    <ul class="listicleBlock">
      <!-- <li class="headline">
        <label style="visibility:hidden">Title
          <span>{{cardData.title ? cardData.title.length : '0'}}/80 char</span>
        </label>
                <div class="dataField">
        <quill-editor [(ngModel)]="cardData.title" [theme]="'snow'" [readOnly]="true">
        </quill-editor>
      </div>
      </li> -->
<!--
      <li class="leadMedia" id="leadMedia">
        <ng-container *ngIf="cardData.listicle && cardData.listicle.inlineElementId">
          <div class="element-module" [EditMode]="false" [id]="cardData.listicle.inlineElementId" [cardId]="cardData.listicle.inlineElementId"
            [hideDragger]="true">
          </div>
        </ng-container>
      </li>-->
      <li class="summary">
        <label style="visibility:hidden">Detail
          <span>{{cardData.listicle.body}}/80 char</span>
        </label>
        <div class="dataField">
          <!-- <textarea type="text" class="textBox" placeholder="Point 1 description" onkeyup="auto_grow(this)"></textarea> -->

          <quill-editor [(ngModel)]="cardData.listicle.body" [theme]="'snow'" [readOnly]="true">

          </quill-editor>
        </div>
      </li>
    </ul>
   
  </ng-container>

  <ng-container *ngIf="cardType === 'liveblog'">
    <ul class="listicleBlock">
      <li class="headline">
        <label style="visibility:hidden">Title
          <span>{{cardData.title ? cardData.title.length : '0'}}/80 char</span>
        </label>
        <!-- <div class="dataField">
                <textarea type="text" class="textBox" placeholder="Point 1 Title" ></textarea> -->
                <div class="dataField">  <quill-editor [(ngModel)]="cardData.title" [theme]="'snow'" [readOnly]="true">
        </quill-editor>
        </div>

      </li>

      <li class="leadMedia" id="leadMedia">
        <ng-container *ngIf="cardData.liveBlog && cardData.liveBlog.inlineElementId">
          <div class="element-module" [EditMode]="false" [id]="cardData.liveBlog.inlineElementId" [cardId]="cardData.liveBlog.inlineElementId"
            [hideDragger]="true">
          </div>
        </ng-container>
      </li>
      <li class="summary">
        <label style="visibility:hidden">Detail
          <span>{{cardData.liveBlog.body}}/80 char</span>
        </label>
        <div class="dataField">
          <!-- <textarea type="text" class="textBox" placeholder="Point 1 description" onkeyup="auto_grow(this)"></textarea> -->

          <quill-editor [(ngModel)]="cardData.liveBlog.body" [theme]="'snow'" [readOnly]="true">

          </quill-editor>
        </div>
      </li>
    </ul>
  </ng-container>

</ng-container>
